import { ref } from 'vue'

export const numberBasket = ref(0)
